import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

import { User } from 'src/app/shared/models/auth/user.model';

@Component({
    selector: 'fury-toolbar-user',
    templateUrl: './toolbar-user.component.html',
    styleUrls: ['./toolbar-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToolbarUserComponent extends BaseComponent implements OnInit {

  public user: User;
  public userName: string;
  public isOpen: boolean;

  constructor(public authService: AuthService, private _globalService: GlobalService) {
    super();
  }

  ngOnInit() {
    this.user = this._globalService.user;
    this.userName = this.user?.name || this.user?.firstName || 'User';
  }

  get userInitial(): string {
    if (!this.userName) return 'U';
    const clean = this.userName.trim();
    return clean ? clean.charAt(0).toUpperCase() : 'U';
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

}
